import { Injectable } from '@angular/core';
import * as asCryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EncryptService {
  constructor() {}

  encrypt(value: string): string {
    return asCryptoJS.AES.encrypt(value, environment.key.trim()).toString()
  }

  decrypt(textToDecrypt: string) {
    return asCryptoJS.AES.decrypt(textToDecrypt, environment.key.trim()).toString(asCryptoJS.enc.Utf8)
  }
}
